import React, { forwardRef, ReactNode } from 'react';
import { Fade as ChakraFade, FadeProps } from '@chakra-ui/react';

interface Props extends Omit<FadeProps, `css`> {
  children: ReactNode;
}

export const Fade = forwardRef<HTMLDivElement, Props>(
  ({ children, ...props }, ref): JSX.Element => {
    return (
      <ChakraFade ref={ref} {...props}>
        {children}
      </ChakraFade>
    );
  }
);

export type { Props as FadeProps };
